import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/earth.svg'


const _withScopeId = n => (_pushScopeId("data-v-5b51722c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sign_config" }
const _hoisted_2 = { class: "drawer_title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "drawer_title_txt" }, "报名配置", -1))
const _hoisted_4 = { class: "config_box" }
const _hoisted_5 = { class: "cetp_input_wrap_change" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "cetp_earth" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))
const _hoisted_7 = { class: "punch_time" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "time_clock" }, "默认选择:", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "head_tip" }, "（没有手机号验证功能）", -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "box_content" }
const _hoisted_12 = { class: "config_name" }
const _hoisted_13 = { class: "config_input" }
const _hoisted_14 = { class: "config_name" }
const _hoisted_15 = { class: "config_input" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "box_content" }
const _hoisted_18 = { class: "config_name" }
const _hoisted_19 = { class: "config_input" }
const _hoisted_20 = { class: "config_name" }
const _hoisted_21 = { class: "config_input" }
const _hoisted_22 = { class: "drawer_footer" }
const _hoisted_23 = { class: "btn_group" }

import { ref } from 'vue';
import router from '@/router';
import { message, Radio } from 'ant-design-vue';
import http from '@/api';


export default /*#__PURE__*/_defineComponent({
  __name: 'SignConfig',
  emits: ['click:onBack', 'click:callbackPage'],
  setup(__props, { emit }) {

const aRadio = Radio;
const aRadioGroup = Radio.Group;


const studioId = router.currentRoute.value.params.studioId;
const onBack = () => {
  emit('click:onBack');
};
const Name = ref('姓名');
const Mobile = ref('手机号');
const enName = ref('name');
const enMobile = ref('mobile');
const customName = ref('姓名');
const customMobile = ref('手机号');
const enCustomName = ref('name');
const enCustomMobile = ref('mobile');
const configType = ref(0);
// 提交
const onSubmit = () => {
  try {
    const data = {
      studio_id: studioId,
      name: configType.value == 0 ? Name.value : customName.value,
      mobile: configType.value == 0 ? Mobile.value : customMobile.value,
      registration_verification_status: configType.value == 0 ? 0 : 1,
      en_name: configType.value == 0 ? enName.value : enCustomName.value,
      en_mobile: configType.value == 0 ? enMobile.value : enCustomMobile.value,
    };
    http.lottery.setRegistrationCopy(data).then((res) => {
      message.success(res.data.message);
      emit('click:callbackPage');
    });
  } catch (err: any) {
    message.error(err);
  }
};

// 详情
const select = ref(0);
const viewValue = ref();
const getConfigInfo = () => {
  const data = {
    studio_id: studioId,
  };
  http.lottery.getConfigInfo({ params: data }).then((res) => {
    viewValue.value = res.data.data.registration_show_copy;
    configType.value = res.data.data.registration_verification_status;
    if (configType.value == 0) {
      Name.value = '姓名';
      Mobile.value = '手机号';
      enName.value = 'name';
      enMobile.value = 'mobile';
    } else {
      customName.value = viewValue.value.name;
      customMobile.value = viewValue.value.mobile;
      enCustomName.value = viewValue.value.en_name;
      enCustomMobile.value = viewValue.value.en_mobile;
    }
  });
};
getConfigInfo();

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_a_button, {
        type: "link",
        class: "drawer_title_back",
        onClick: onBack
      }, {
        default: _withCtx(() => [
          _createTextVNode("返回>>")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", {
          class: "cept_china",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (select.value = 0)),
          style: _normalizeStyle({ color: select.value == 1 ? '#ccc' : '' })
        }, "中", 4),
        _createTextVNode(" / "),
        _createElementVNode("div", {
          class: "cept_eng",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (select.value = 1)),
          style: _normalizeStyle({ color: select.value == 0 ? '#ccc' : '' })
        }, "ENG", 4)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(_unref(aRadioGroup), {
          value: configType.value,
          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((configType).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(aRadio), {
              value: 0,
              class: "one"
            }, {
              default: _withCtx(() => [
                _createTextVNode("默认")
              ]),
              _: 1
            }),
            _createVNode(_unref(aRadio), { value: 1 }, {
              default: _withCtx(() => [
                _createTextVNode("自定义"),
                _hoisted_9
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["value"])
      ]),
      (configType.value == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createTextVNode(" 文本标题1: "),
                _createElementVNode("div", _hoisted_13, [
                  (select.value == 0)
                    ? (_openBlock(), _createBlock(_component_a_input, {
                        key: 0,
                        value: Name.value,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((Name).value = $event)),
                        class: "dicf_item_input",
                        disabled: ""
                      }, null, 8, ["value"]))
                    : (_openBlock(), _createBlock(_component_a_input, {
                        key: 1,
                        value: enName.value,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((enName).value = $event)),
                        class: "dicf_item_input",
                        disabled: ""
                      }, null, 8, ["value"]))
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createTextVNode(" 文本标题2: "),
                _createElementVNode("div", _hoisted_15, [
                  (select.value == 0)
                    ? (_openBlock(), _createBlock(_component_a_input, {
                        key: 0,
                        value: Mobile.value,
                        "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((Mobile).value = $event)),
                        class: "dicf_item_input",
                        disabled: ""
                      }, null, 8, ["value"]))
                    : (_openBlock(), _createBlock(_component_a_input, {
                        key: 1,
                        value: enMobile.value,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((enMobile).value = $event)),
                        class: "dicf_item_input",
                        disabled: ""
                      }, null, 8, ["value"]))
                ])
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createTextVNode(" 文本标题1: "),
                _createElementVNode("div", _hoisted_19, [
                  (select.value == 0)
                    ? (_openBlock(), _createBlock(_component_a_input, {
                        key: 0,
                        value: customName.value,
                        "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((customName).value = $event)),
                        class: "dicf_item_input"
                      }, null, 8, ["value"]))
                    : (_openBlock(), _createBlock(_component_a_input, {
                        key: 1,
                        value: enCustomName.value,
                        "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((enCustomName).value = $event)),
                        class: "dicf_item_input"
                      }, null, 8, ["value"]))
                ])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createTextVNode(" 文本标题2: "),
                _createElementVNode("div", _hoisted_21, [
                  (select.value == 0)
                    ? (_openBlock(), _createBlock(_component_a_input, {
                        key: 0,
                        value: customMobile.value,
                        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((customMobile).value = $event)),
                        class: "dicf_item_input"
                      }, null, 8, ["value"]))
                    : (_openBlock(), _createBlock(_component_a_input, {
                        key: 1,
                        value: enCustomMobile.value,
                        "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((enCustomMobile).value = $event)),
                        class: "dicf_item_input"
                      }, null, 8, ["value"]))
                ])
              ])
            ])
          ]))
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_a_button, {
          class: "mod_modal_btn",
          onClick: onBack
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_component_a_button, {
          class: "mod_modal_btn mod_type_primary",
          onClick: onSubmit
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})